import { useMutation } from '@apollo/client/react';
import { Button } from 'components/ui';
import { useInfo } from 'contexts/info';
import { useError } from 'contexts/error';
import { FormattedMessage } from 'react-intl';
import DeleteMutation from 'mutations/user/delete_request';
import Confimation from 'components/form/confirmation';

const DeleteButton = () => {
  const setInfo = useInfo();
  const setError = useError();

  const [deleteMutation, deleteMutationData] = useMutation(DeleteMutation, {
    onCompleted: ({ userDeleteRequest }) => {
      if (userDeleteRequest.success) {
        setInfo('info.user.account.delete_requested');
      } else {
        setError('error.user.account.delete_requested');
      }
    },
    onError: () => {
      setError('error.user.account.delete_requested');
    },
  });

  return (
    <Confimation
      title={<FormattedMessage id="header.user.account.delete" />}
      description={<FormattedMessage id="confirmation.user.account.delete" />}
      onClick={deleteMutation}
    >
      <Button color="error" variant="outlined" disabled={deleteMutationData.loading}>
        <FormattedMessage id="button.delete_account" />
      </Button>
    </Confimation>
  );
};

export default DeleteButton;
